import { ApolloError } from "apollo-client";
import React, { Component } from "react";
import { translate } from "react-polyglot";
import { UncontrolledCarousel } from "reactstrap";
import {
  BuildupTemplateComponent,
  BuildupTemplateQuery
} from "../../generated/graphql";

interface IProps {
  templateId: string;
}

class ViewBuildupParameters extends Component<IProps & TranslateProps> {
  public render() {
    const { templateId } = this.props;
    return (
      <BuildupTemplateComponent variables={{ id: templateId }}>
        {({ loading, error, data }) => this.renderState(loading, error, data)}
      </BuildupTemplateComponent>
    );
  }

  private renderState(
    loading: boolean,
    error: ApolloError | undefined,
    data: BuildupTemplateQuery | undefined
  ) {
    if (loading) {
      return this.renderLoading();
    }
    if (error) {
      return this.renderError(error);
    }

    return this.renderData(data);
  }

  private renderError(error: ApolloError | undefined) {
    const { t } = this.props;
    return <p>{t("errors.failedToFetch")}</p>;
  }

  private renderLoading() {
    const { t } = this.props;
    return <p>{t("labels.loading")}</p>;
  }

  private renderData(data: BuildupTemplateQuery | undefined) {
    const { t } = this.props;
    if (!data || !data.buildupTemplate) {
      return t("errors.noData");
    }
    const {
      buildupTemplate: { images }
    } = data;

    const items = images.map(image => {
      return {
        altText: image.name,
        caption: "",
        src: image.location
      };
    });

    return (
      <UncontrolledCarousel autoPlay={false} interval={false} items={items} />
    );
  }
}

export default translate()(ViewBuildupParameters);
